import { useEffect, useState } from 'react';

import { setAddOns, setBasket, setMonthlyFlex } from 'actions/expiryRenewalActions';
import { dispatch } from 'store';
import { PageModel, PaidUpgrade } from 'types/expiryRenewal';
import calculateBasketPricing, { BasketPricing } from 'views/MyRac/ExpiryRenewal/utils/pricingUtils';

const useBasketPricing = (
  selected: PaidUpgrade[],
  monthlyFlex: boolean,
  pageModel: PageModel | null,
  vehiclesAdded = 0,
  peopleAdded = 0,
  removedExtras: string[] = [],
) => {
  const [pricing, setPricing] = useState<BasketPricing>({ totalPrice: 0, addOnTotal: 0, wasTotal: null });
  const isMonthlyLongerTermPolicy = !!pageModel?.isMonthlyLongerTermPolicy;

  useEffect(() => {
    const result = calculateBasketPricing(selected, monthlyFlex || isMonthlyLongerTermPolicy, pageModel, vehiclesAdded, peopleAdded, removedExtras);
    setPricing(result);

    const { isEligibleForMonthlyFlex, price } = pageModel || {};
    dispatch(setAddOns(selected));
    dispatch(setMonthlyFlex(monthlyFlex));
    dispatch(setBasket(isEligibleForMonthlyFlex ? result.totalPrice + result.addOnTotal : price, result.wasTotal));
  }, [selected, monthlyFlex, pageModel, vehiclesAdded, peopleAdded, removedExtras, pageModel?.isMonthlyLongerTermPolicy]);

  return pricing;
};

export default useBasketPricing;
